import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import type { ZElement } from "./ZElement";
import { v3 } from "oc-threejs/short3";
import { Box3, Vector3 } from "three";
import { ProfilHighlighter3D } from "../arrangement3d/ProfilHighlighter3D";
import { ModelGhost } from "oc-jaco3d/arrangement/ModelGhost";

const getProfilBox = (profil: ModelGhost) => {
  const box = profil.getBox() as any;
  const pos = v3(profil.position) as any;
  const boxCenter = box.getCenter(v3() as Vector3);
  pos.add(v3(boxCenter.x, boxCenter.y, 0));
  return (new Box3() as any).setFromCenterAndSize(pos, box.getSize(v3()));
};

export class ProfilHighlighter extends Jaco {
  element: ZElement;
  box: any;
  highlighted = false;

  constructor(parent: Jaco, element: ZElement, profile: ModelGhost[]) {
    super(parent);
    this.element = element;
    this.box = profile.reduce((box, profil) => box.union(getProfilBox(profil)), new Box3() as any);
    this.position.copy(this.box.getCenter(v3()));
  }

  update3d() {
    super.update3d();
    this.updateHighlight();
  }

  updateHighlight() {
    this.highlighted =
      this.element == APP.arrangement.selectedObjects[0] && APP.arrangement.highlightProfileActive;
  }

  getSize() {
    return this.box.getSize(v3());
  }

  getBox() {
    return (new Box3() as any).union(this.box);
  }

  createJaco3d() {
    return new ProfilHighlighter3D(this);
  }
}
